var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dust-animation-container"},_vm._l((_vm.dustParticles),function(dust,index){return _c('div',{key:`dust-${index}`,staticClass:"dust-particle",style:({
            left: dust.left + '%',
            top: dust.top + '%',
            animationDelay: dust.delay + 's',
            animationDuration: dust.duration + 's',
            width: dust.size + 'px',
            height: dust.size + 'px',
        })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }